var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card border-warn"},[_c('article',{staticClass:"flex gap-3 !p-2 card-content items-center"},[_c('i',{staticClass:"bi-exclamation-triangle-fill text-amber-500 ml-2"}),_c('div',{staticClass:"whitespace-break-spaces"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }